import React from 'react';

/**
 * Pager for server-side paginated tables.
 *
 * `total` is the FULL collection size (Steve's `count`), not the number of rows on
 * screen — that is what lets us show "page 3 of 26" rather than just next/prev.
 *
 * Deliberately dumb: it owns no data and no fetching. The page holds `page` state and
 * refetches when it changes, so this stays reusable for any paged list.
 */
export default function Pager({ page, pageSize, total, loading, onPage, onPageSize }) {
  const pages = Math.max(1, Math.ceil((total || 0) / (pageSize || 1)));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total || 0);

  // Nothing to page through — keep the count visible but hide the controls, so a
  // single-page table doesn't grow dead buttons.
  const single = pages <= 1;

  return (
    <div className="pager" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0', flexWrap: 'wrap' }}>
      <span className="resource-count">
        {total === 0 ? 'No items' : `${from}–${to} of ${total}`}
      </span>

      {!single && (
        <>
          <button className="button" disabled={loading || page <= 1} onClick={() => onPage(1)}>« First</button>
          <button className="button" disabled={loading || page <= 1} onClick={() => onPage(page - 1)}>‹ Prev</button>
          <span style={{ minWidth: 90, textAlign: 'center' }}>Page {page} / {pages}</span>
          <button className="button" disabled={loading || page >= pages} onClick={() => onPage(page + 1)}>Next ›</button>
          <button className="button" disabled={loading || page >= pages} onClick={() => onPage(pages)}>Last »</button>
        </>
      )}

      {onPageSize && (
        <label style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6 }}>
          Rows
          <select
            value={pageSize}
            disabled={loading}
            onChange={(e) => onPageSize(Number(e.target.value))}
          >
            {[25, 50, 100, 200].map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
        </label>
      )}
    </div>
  );
}
